import "@fontsource/raleway";
import { jwtDecode } from "jwt-decode";
import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AboutUs from "../Pages/AboutUs";
import AdminDashboard from "../Pages/Admin/AdminDashboard";
import ContactUs from "../Pages/ContactUs";
import HomeScreen from "../Pages/HomeScreen";
import MarketPlace from "../Pages/Marketplace";
import Profile from "../Pages/Profile";
import PropertyDetail from "../Pages/PropertyDetail";
import Questionnaire from "../Pages/Questionnaire";
import SubmitYourProperty from "../Pages/SubmitYourProperty";
import './App.css';
import LandingPgHeader from "../../Components/Header/LandingPgHeader";

function App() {
  let isLoggedIn;
  let token;
  let decodedJWT;

  const checkLoginStatus = () => {
    console.log("Login status checked")
    token = sessionStorage.getItem('token')
    if (token) {
      isLoggedIn = true;
      decodedJWT = jwtDecode(token);
      console.log("Decoded jwt => ", decodedJWT);
    } else {
      isLoggedIn = false;
    }
  }

  useEffect(() => {
    checkLoginStatus();
  }, [])

  const PrivateRoute = ({ path, ...rest }) => {
    console.log("Coming in private route");
    checkLoginStatus();
    if (isLoggedIn && token) {
      if (decodedJWT.role === 'Admin') {
        if (path === "/admin-dashboard/*") {
          // console.log("Coming in admin side");
          return <AdminDashboard />
        } else if (path === '/property/:id') {
          return <PropertyDetail />
        } else if (path === "/marketplace") {
          return <MarketPlace />
        } else if (path === "/property/:id") {
          return <PropertyDetail />
        }
      } else {
        if (path === '/marketplace') {
          return <MarketPlace />
        } else if (path === '/contactus') {
          return <ContactUs />
        } else if (path === '/profile/*') {
          return <Profile />
        } else if (path === '/questionnaire') {
          return <Questionnaire />
        } else if (path === '/property/:id') {
          return <PropertyDetail />
        } else {
          return <Navigate to='/' replace={true} />
        }
      }
    } else {
      return <Navigate to='/' replace={true} />
    }
  }

  const LoginRegisterRedirectCheck = ({ path, ...rest }) => {
    checkLoginStatus();
    return (
      // isLoggedIn && token && decodedJWT.role === 'Admin' ? (
      //   <Navigate to='/admin-dashboard' />
      // ) : 
      path === "/contactus" ? (
        <ContactUs />
      ) : path === "/aboutus" ? (
        <AboutUs />
      ) : path === '/profile' ? (
        <Profile />
      ) : path === "/submitYourProperty" ? (
        <SubmitYourProperty />
      ) : (
        <HomeScreen />
      )
    );
  };


  return (
    <BrowserRouter>
      <LandingPgHeader/>
      <Routes>
        <Route path="/" element={<LoginRegisterRedirectCheck exact path="/" />} />
        <Route path="/marketplace" element={<PrivateRoute exact path="/marketplace" />} />
        <Route path="/contactus" element={<LoginRegisterRedirectCheck exact path="/contactus" />} />
        <Route path="/aboutus" element={<LoginRegisterRedirectCheck exact path="/aboutus" />} />
        <Route path='/profile/*' element={<PrivateRoute exact path="/profile/*" />} />
        <Route path="/submitYourProperty" element={<LoginRegisterRedirectCheck exact path="/submitYourProperty" />} />
        <Route path="/questionnaire" element={<PrivateRoute exact path="/questionnaire" />} />
        <Route path="/property/:id" element={<PrivateRoute exact path="/property/:id" />} />
        <Route path="/admin-dashboard/*" element={<PrivateRoute exact path="/admin-dashboard/*" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
